import { translate } from "@kaltura/mediaspace-shared-utils";
import { Link } from "@kaltura/ds-react-components";
import React from "react";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

/**
 * forgot-password info, matches the config object used in KMS's Kms_View_Helper_ForgotPasswordLink
 */
export interface ForgotPwdLinkInfo {
    link: string;
    emailSubject?: string;
    emailBody?: string;
}

export function ForgotPasswordLink({ link, emailSubject = "", emailBody = "" }: ForgotPwdLinkInfo) {
    let url: string | undefined, atts;
    if (emailSubject || emailBody) {
        url = `${link}?subject=${emailSubject}&body=${emailBody}`;
        atts = {};
    }
    else {
        url = link;
        atts = {
            target: "_blank",
            rel: "noopener noreferrer",
        };
    }

    const sendButtonAnalytics = useButtonAnalytics();

    const sendAnalytics = () => {
        sendButtonAnalytics("Login - Forgot Password", ButtonClickAnalyticsType.LOGIN);
    };

    return (
        <Link
            className={"kms-ds-login-forgot-password-link"}
            size={"small"}
            href={url}
            onClick={sendAnalytics}
            {...atts}
        >
            {translate("Forgot Password")}
        </Link>
    );
}

export default ForgotPasswordLink;
